<template>
  <v-dialog v-model="isOpen" persistent width="1000px">
    <template>
      <v-card tile>
        <v-toolbar flat dark color="rgb(51, 97, 137)">
          <v-toolbar-title>
            <v-icon left>mdi-account-multiple</v-icon>
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.accessStep.manageLearners.requestJoinGroup'
              )
            }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn icon dark @click="isClose" v-on="on">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
            <span class="subtitle-1">
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.tooltripClose'
                )
              }}
            </span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <template>
                <div>
                  <v-data-table
                    :headers="headersUser"
                    :items="userRequest"
                    hide-default-footer
                    class="elevation-1 mt-5"
                  >
                    <template v-slot:item.image="{ item }">
                      <v-avatar
                        :color="`grey lighten-2`"
                        elevation="3"
                        size="45"
                        class="my-2"
                      >
                        <v-img
                          :src="item.image"
                          class="my-2 ml-auto mr-auto rounded-card img-md"
                          aspect-ratio="1"
                          width="60"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-icon
                                v-if="!item.image"
                                class="mx-auto"
                                elevation="3"
                                size="65"
                                >mdi-account</v-icon
                              >
                            </v-row>
                          </template>
                        </v-img>
                      </v-avatar>
                    </template>
                    <template v-slot:item.group="{ item }">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-if="item.group.length <= 1"
                            class="text-capitalize button-secondary body-2 font-weight-light"
                            small
                            elevation="0"
                            v-on="on"
                          >
                            {{ item.group.length }}
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.accessStep.manageLearners.group'
                              )
                            }}
                          </v-btn>
                          <v-btn
                            v-if="item.group.length > 1"
                            class="text-capitalize button-secondary body-2 font-weight-light"
                            small
                            elevation="0"
                            v-on="on"
                          >
                            {{ item.group.length }}
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.accessStep.manageLearners.groups'
                              )
                            }}
                          </v-btn>
                        </template>
                        <div class="text-center">
                          <span class="subtitle-1 mx-2">
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.accessStep.manageLearners.groupsLg'
                              )
                            }}
                          </span>
                        </div>
                        <v-divider dark></v-divider>
                        <v-chip-group column class="md-fixed-max-width">
                          <v-chip
                            label
                            small
                            class="ma-2"
                            v-for="group in item.group"
                            :key="group._id"
                          >
                            <div class="mb-0 caption">{{ group.title }}</div>
                          </v-chip>
                        </v-chip-group>
                      </v-tooltip>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        @click="openRejectDialog(item)"
                        elevation="0"
                        class="pl-5 pr-5 mr-5 xs-full-width font-weight-light body-2 button-secondary"
                      >
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.accessStep.manageLearners.remove'
                          )
                        }}
                      </v-btn>
                      <v-btn
                        @click="acceptUser(item)"
                        elevation="0"
                        class="pl-5 pr-5 xs-full-width font-weight-light button-primary white--text"
                      >
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.accessStep.manageLearners.approve'
                          )
                        }}
                      </v-btn>
                    </template>
                  </v-data-table>
                  <div class="text-center pt-2">
                    <v-pagination
                      v-model="requestPage"
                      :length="maxRequestPage"
                      @input="changeRequestPage"
                    ></v-pagination>
                  </div>
                </div>
              </template>
            </v-col>
          </v-row>
        </v-card-text>
        <v-dialog v-model="exp_date_dialog" scrollable max-width="450px">
          <v-card>
            <v-toolbar flat dark color="rgb(51, 97, 137)">
              <v-toolbar-title>
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.accessStep.manageLearners.specifyExpDate'
                  )
                }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="closeDialogDateExp">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col lg="12">
                    <p class="mb-0">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.accessStep.manageLearners.expType'
                        )
                      }}
                    </p>
                    <v-radio-group v-model="date_type" row>
                      <v-radio
                        :label="
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.accessStep.manageLearners.lifeTime'
                          )
                        "
                        value="type_life_time"
                      ></v-radio>
                      <v-radio
                        :label="
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.accessStep.manageLearners.chooseDate'
                          )
                        "
                        value="type_spectify_exp"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row v-if="date_type == 'type_spectify_exp'">
                  <v-col lg="12">
                    <p class="mb-2">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.accessStep.manageLearners.selectExpDate'
                        )
                      }}
                    </p>
                    <v-menu
                      ref="menu1"
                      v-model="menu1"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="date"
                          outlined
                          persistent-hint
                          prepend-icon="event"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="date"
                        no-title
                        @input="menu1 = false"
                        :min="nowdate"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                @click="saveEditDateExp"
                elevation="0"
                class="pl-5 pr-5 xs-full-width font-weight-light button-primary white--text"
              >
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.accessStep.manageLearners.save'
                  )
                }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" persistent max-width="460">
          <v-card>
            <v-card-title class="headline">
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.accessStep.manageLearners.confirmRemove'
                )
              }}
            </v-card-title>
            <!-- <v-card-text>หากทำการลบแล้วผู้เรียนจะถูกย้ายไปอยู่ที่ "คำร้องขอเข้ากลุ่มเรียน"</v-card-text> -->

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="grey darken-1"
                class="px-9 ma-2"
                dark
                outlined
                @click="closeDialogReject"
              >
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.cancel'
                  )
                }}
              </v-btn>
              <v-btn
                class="px-10 ma-2"
                color="error darken-1"
                dark
                @click="rejectUser"
              >
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.confirm'
                  )
                }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDeleteSuccess" max-width="450">
          <v-card>
            <v-card-title class="headline">
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.accessStep.manageLearners.successRemove'
                )
              }}
            </v-card-title>

            <v-card-text>
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.accessStep.manageLearners.successRemoveDetail'
                )
              }}
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="green darken-1"
                text
                @click="dialogDeleteSuccess = false"
              >
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.accessStep.manageLearners.done'
                  )
                }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import {
  getUserRequestBySearch,
  acceptToCourse,
  getUserAccept,
  rejectUserInCourse,
  removeUserInCourse,
  uploadUserInCourse,
  getUserBySearch,
  addUserInCourseBySearch,
  uploadUserToPreview,
  insertStudentToCourse,
  getCourseListAll,
  // getRoomStudentList,
  getRoomStudentMylib,
  editDateExp,
} from '@/service/mylib/list';
import { getTotalRequest } from '@/service/account/login';

import { getCourseById } from '@/service/course/course';
import { getRoom } from '@/service/room/room';
import { getUserGroup } from '@/service/account/manageUser';
import store from './../../store';

export default {
  components: {
    // UploadExcelComponent,
  },
  props: {
    isOpen: {
      type: Boolean,
    },
    isClose: {
      type: Function,
    },
    updateLearnerRequest: {
      type: Function,
    },
    courseId: {
      type: String,
    },
    sectionID: {
      type: String,
    },
  },

  watch: {
    isOpen: async function (newValue) {
      if (newValue) {
        await this.initialize();
        await this.getlistUser();
        this.getCourseDetail();
        this.setMainTabs();

        this.getRoomList();
      }
    },
    searchData() {
      this.searchUserInfo();
    },
    importDialog: async function (newValue) {
      if (newValue) {
        this.listRoom = await this.getRoomByCourseId();
      }
    },
    // searchStudentUserInfo: async function(val) {
    //   console.log("Yes", "val");
    //   this.userSearched = [];
    //   let resultSearch = [];
    //   if (val.length > 1) {
    //     let result = await getUserBySearch(val);
    //     await result.forEach(async user => {
    //       await resultSearch.push({
    //         name: user.firstName + " " + user.lastName,
    //         id: user._id
    //         // status: await this.checkStatus(user.myCourses),
    //         // group: user.user_groups.length > 0 ? user.user_groups : [],
    //         // image: user.image ? user.image : ""
    //       });
    //     });
    //   }
    //   this.userSearched = resultSearch;
    // }
  },

  data: () => ({
    //user
    template:
      'https://s3-ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/template/template-import.xlsx',
    userFile: '',
    main_tabs: '',
    page: 1,
    pageStd: 1,
    pageSearch: 1,
    pageCountUser: 0,
    pageCountStd: 0,
    pageCountSearch: 0,
    itemsPerPageUser: 10,
    // loading: false,
    dialogDelete: false,
    dialogDeleteSuccess: false,
    searchData: '',
    search: null,
    selectedRoom: null,

    userRequest: [],
    userAccept: [],
    userSearch: [],
    studentRoom: [],

    userSearched: [],
    searchUserData: [],
    searchStudentUserInfo: null,

    pageFail: 1,
    pageFailCount: 1,
    pageSuccess: 1,
    pageSuccessCount: 1,
    pageRepeat: 1,
    pageRepeatCount: 1,

    acceptPage: 1,
    maxAcceptPage: 1,
    acceptLimit: 10,
    totalAccept: 0,
    checkAccept: null,

    requestPage: 1,
    maxRequestPage: 1,
    requestLimit: 10,
    totalRequest: 1,

    //dialog
    dialog: false,
    removeDialog: false,
    rejectDialog: false,
    excelDialog: false,
    importDialog: false,
    exp_date_dialog: false,
    dialogAddUserFromGroup: false,

    //remove item
    remove_item: '',
    reject_item: '',

    //item search
    item_search: '',

    //file
    tableData: [],

    pageUserUploadCount: 0,
    pageUserUpload: 1,
    excelFile: '',
    //urlDownload: "https://s3-amr.deknerd.com/template/template-import.xlsx",
    showExampleTable: true,
    showTabsResult: false,
    tabResult: 'fail',
    userUploadFail: [],
    userUploadRepeat: [],
    userUploadSuccess: [],

    //warrning
    textWarning: '',
    typeWarning: '',
    showWarnnig: false,

    // status add by search
    status_add: false,
    test_add: '',

    //course detail
    detail: [],
    listRoom: [],
    roomList: [],
    arrayRoom: [],
    courseList: [],
    selectRoom: null,
    // selectRoom: this.sectionID,
    room_headers: [
      {
        text: 'ชื่อกลุ่ม',
        align: 'start',
        sortable: false,
        value: 'title',
      },
      {
        text: 'ชื่ออาจารย์',
        value: 'teacher',
        sortable: false,
      },
      {
        text: 'จำนวนผู้เรียน',
        value: 'countStudent',
        sortable: false,
        align: 'center',
      },

      {
        text: 'เลือกกลุ่ม',
        sortable: false,
        align: 'center',
        value: 'select',
      },
    ],

    //date
    date: new Date().toISOString().substr(0, 10),
    nowdate: new Date().toISOString().substr(0, 10),
    menu1: false,
    date_type: 'type_life_time',
    data_type: '',
  }),
  // async beforeMount(){
  //   this.listRoom = await this.getRoomByCourseId()
  // },
  // mounted() {
  //   // this.initialize();
  // },

  computed: {
    headersUser() {
      return [
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.profile'
          ),
          align: 'center',
          sortable: false,
          value: 'image',
          width: '15%',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.fullName'
          ),
          value: 'name',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.email'
          ),
          value: 'email',
          sortable: false,
        },
        // {
        //   text: this.$vuetify.lang.t(
        //     '$vuetify.courseManagement.accessStep.manageLearners.username'
        //   ),
        //   value: 'username',
        //   sortable: false,
        // },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.group'
          ),
          value: 'group',
          sortable: false,
          align: 'center',
        },
        // {
        //   text: this.$vuetify.lang.t(
        //     '$vuetify.courseManagement.accessStep.manageLearners.status'
        //   ),
        //   value: 'status',
        //   sortable: false,
        //   align: 'center',
        // },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.action'
          ),
          value: 'actions',
          sortable: false,
          align: 'center',
          width: '30%',
        },
      ];
    },

    tableHeader() {
      return [
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.username'
          ),
          value: 'username',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.firstName'
          ),
          value: 'name',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.lastName'
          ),
          value: 'lastname',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.email'
          ),
          value: 'email',
          sortable: false,
        },
      ];
    },
    tableHeaderPreview() {
      return [
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.username'
          ),
          value: 'username',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.firstName'
          ),
          value: 'firstName',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.lastName'
          ),
          value: 'lastName',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.email'
          ),
          value: 'email',
          sortable: false,
        },
      ];
    },
    tableHeaderFailPreview() {
      return [
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.username'
          ),
          value: 'username',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.remark'
          ),
          value: 'note',
          sortable: false,
        },
      ];
    },
    headersSearch() {
      return [
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.profile'
          ),
          align: 'center',
          sortable: false,
          value: 'image',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.fullName'
          ),
          value: 'name',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.group'
          ),
          value: 'group',
          sortable: false,
          align: 'center',
        },
        {
          text: '',
          value: 'status',
          sortable: false,
          align: 'center',
        },
        //{ text: "Actions", value: "actions", sortable: false, align: "center" }
      ];
    },
    headersStudent() {
      return [
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.profile'
          ),
          align: 'center',
          sortable: false,
          value: 'image',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.fullName'
          ),
          value: 'name',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.group'
          ),
          value: 'group',
          sortable: false,
          align: 'center',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.status'
          ),
          value: 'status',
          sortable: false,
        },
      ];
    },
  },

  methods: {
    async initialize() {
      this.paramsG = {
        idcourse: this.courseId,
        page: this.page,
        limit: 10,
      };
      // await this.getRoomList();
      // console.log("room id: ",this.sectionID)
      await this.getUserGroupList();
    },
    closeDialogDateExp() {
      this.exp_date_dialog = false;

      this.date = new Date().toISOString().substr(0, 10);
      this.nowdate = new Date().toISOString().substr(0, 10);
      this.menu1 = false;
      this.date_type = 'type_life_time';
    },
    async getUserGroupList() {
      let result = await getUserGroup({
        idcourse: this.courseId,
      });
      this.groupUsers = [];
      // let userGroupAllAtIndex=[]
      this.arrayGroup = [];
      await result.forEach(async (group) => {
        // let arrayGroup = []
        group.child_User_Group.length === 0
          ? await this.groupUsers.push({
              title: group.title,
              _id: group._id,
            })
          : null;
        group.child_User_Group.forEach(async (child) => {
          child.child_User_Group.length === 0
            ? await this.groupUsers.push({
                title: group.title + ' -> ' + child.title,
                _id: child._id,
              })
            : null;
          child.child_User_Group.forEach(async (lastChild) => {
            await this.groupUsers.push({
              title:
                group.title + ' -> ' + child.title + ' -> ' + lastChild.title,
              _id: lastChild._id,
            });
          });
        });
        // await userGroupAllAtIndex.push({arrayGroup})
      });
      this.arrayGroup = this.groupUsers;
      console.log('array group : ', this.arrayGroup);
      // this.groupUsers = result;
      // this.filterGroupResult = result;
    },
    async getRoomList() {
      console.log('room id: ', this.sectionID);

      let result = await getCourseListAll();
      this.roomList = [];
      result.forEach(async (courselist) => {
        if (courselist.room.length > 0 && this.courseId != courselist._id) {
          this.roomList.push({
            header: courselist.title,
          });
          courselist.room.forEach((rooms) => {
            if (
              rooms._id != this.sectionID &&
              this.courseId != courselist._id
            ) {
              // if(rooms.countStudent > 0){
              this.roomList.push({
                idcourse: courselist._id,
                idroom: rooms._id,
                name: rooms.title,
                countStudent: rooms.countStudent,
                ownerRoom: rooms.teacher ? rooms.teacher.displayName : 'null',
              });
              // }
            }
          });
          this.roomList.push({
            divider: true,
          });
        }
      });

      console.log('room list : ', this.roomList);
    },
    async previewStudent(idcourse, idroom) {
      console.log(idcourse, ' : ', idroom);
      this.idCourse = idcourse;
      this.idRoom = idroom;
      this.studentRoom = [];
      let resultStudentList = [];
      // let resultStudent = await getRoomStudentList({
      //   idroom: this.idRoom,
      //   idcourse: this.idCourse
      // });
      let resultStudent = await getRoomStudentMylib({
        idroom: this.idRoom,
        idcourse: this.idCourse,
        idcourseadd: this.courseId,
        page: this.pageStd,
        limit: 10,
      });
      console.log(resultStudent);
      this.pageCountStd = resultStudent.maxPage;
      await resultStudent.data.forEach(async (student) => {
        await resultStudentList.push({
          id: student.idStudent,
          image: student.image,
          name: student.firstName + ' ' + student.lastName,
          status: student.ismylib,
          group: await this.showGroupList(student.user_groups),
          // group: student.user_groups
        });
      });
      this.studentRoom = resultStudentList;
      console.log('student list : ', this.studentRoom);
    },
    async changePage(page) {
      console.log('page : ', page);
      this.pageStd = page;
      await this.previewStudent(this.idCourse, this.idRoom);
    },
    async changePageSearch(page) {
      console.log('page : ', page);
      this.pageSearch = page;
      await this.searchUserInfo();
    },
    async showGroupList(userGroup) {
      console.log('show group list : ', userGroup);
      let userGroupOutput = [];
      await userGroup.forEach(
        async (grouplist) =>
          await this.arrayGroup.forEach(async (group) =>
            group._id == grouplist._id
              ? await userGroupOutput.push(group)
              : null
          )
      );
      return userGroupOutput;
    },
    async getRoomByCourseId() {
      let result = await getRoom({
        idcourse: this.courseId,
      });
      // this.pageCount = Math.ceil(result.length / this.limit)
      let tempRoom = [];
      await result.forEach(async (room) => {
        await tempRoom.push({
          _id: room._id,
          title:
            room.title +
            ' - ' +
            room.teacher.displayName +
            '(' +
            room.countStudent +
            ' ผู้เรียน )',
          // title: room.title,
          // countStudent: room.countStudent
        });
      });
    },

    setMainTabs() {
      this.main_tabs = 'accept';
    },
    //user
    async getlistUser() {
      await this.acceptListInfo();
      await this.requestListInfo();
    },
    async getCourseDetail() {
      console.log('courseID', this.courseId);
      let params = {
        id: this.courseId,
      };

      let detail = await getCourseById(params);
      console.log(detail);
      this.detail = detail;
      console.log('this.detail.prices[0]._id', this.detail.prices[0]._id);
    },
    async searchUserInfo() {
      this.loading = true;
      this.userSearch = [];
      let resultSearch = [];
      if (this.searchData.length > 1) {
        // let data = {
        //   search: this.searchData,
        //   page: this.pageSearch,
        //   limit: 10
        // }
        let result = await getUserBySearch({
          search: this.searchData,
          page: this.pageSearch,
          limit: 10,
        });
        this.pageCountSearch = result.maxPage;
        await result.data.forEach(async (user) => {
          await resultSearch.push({
            name: user.firstName + ' ' + user.lastName,
            id: user._id,
            status: await this.checkStatus(
              user.myCourses,
              user.myCoursesRequest
            ),
            // group: user.user_groups.length > 0 ? user.user_groups : [],
            group: await this.showGroupList(user.user_groups),
            image: user.image ? user.image : '',
          });
        });
      }

      // this.userSearch = resultSearch.filter(user => user.status.length == 0);
      this.userSearch = resultSearch;

      console.log('searchUserInfo', this.userSearch);
    },
    checkStatus(myCourses, myCoursesRequest) {
      console.log('mycourse', myCourses);
      let course = [];
      if (myCourses.length > 0) {
        for (let i = 0; i < myCourses.length; i++) {
          if (myCourses[i]._id == this.courseId) {
            course.push(myCourses[i]);
          }
        }
      }
      if (myCoursesRequest.length > 0) {
        for (let i = 0; i < myCoursesRequest.length; i++) {
          if (myCoursesRequest[i] == this.courseId) {
            course.push(myCoursesRequest[i]);
          }
        }
      }
      return course;
    },
    async requestListInfo() {
      this.loading = true;
      this.userRequest = [];
      let result = await getUserRequestBySearch({
        idcourse: this.courseId,
        idroom: this.sectionID,
        page: this.requestPage,
        limit: this.requestLimit,
      });
      this.maxRequestPage = result.maxPage;
      this.totalRequest = result.count;
      console.log('result', result);
      if (result) {
        this.loading = false;
        result.data.forEach(async (user) => {
          this.userRequest.push({
            image: user.image ? user.image : '',
            name: user.firstName + ' ' + user.lastName,
            email: user.email,
            username: user.username,
            id: user._id,
            status: this.checkStatusTeacher(user.isTeacher),
            acceptMylib: user.acceptMylib,
            // group: user.user_groups
            group: await this.showGroupList(user.user_groups),
          });
        });
      }
    },
    checkStatusTeacher(teacherStatus) {
      if (teacherStatus === 'y') {
        return 'ครู';
      } else if (teacherStatus === 'w') {
        return 'รออนุมัติเป็นครู';
      } else {
        return 'ผู้เรียน';
      }
    },
    async acceptUser(item) {
      this.exp_date_dialog = true;
      this.acceptUserByRequest = item;
      console.log('accept user Type item : ', this.acceptUserByRequest);
    },

    async saveEditDateExp() {
      let resultAccept = await acceptToCourse({
        id: this.acceptUserByRequest.id,
      });

      if (resultAccept) {
        let date = new Date(this.date).toISOString().substr(0, 10);

        let dt_start = new Date(date + ',' + '00' + ':' + '00');
        var startTime = dt_start.setTime(
          dt_start.getTime() - new Date().getTimezoneOffset() * 60 * 1000
        );
        let data = {
          idmylib: this.acceptUserByRequest.id,
          exp: this.date_type == 'type_spectify_exp' ? startTime : 0,
        };
        let result = await editDateExp(data);
        if (result) {
          // this.dialogSuccessEditDateExp = true;
          let resultTotalRequest = await getTotalRequest();
          store.commit('setTotal', resultTotalRequest.course);
          this.getlistUser();
          // this.updateLearnerRequest();
          this.exp_date_dialog = false;
        }
      }
    },

    async acceptListInfo() {
      this.loading = true;
      this.userAccept = [];

      let result = await getUserAccept({
        idcourse: this.courseId,
        idroom: this.sectionID,
        page: this.acceptPage,
        limit: this.acceptLimit,
      });
      this.maxAcceptPage = result.maxPage;
      this.totalAccept = result.count;
      if (result) {
        this.loading = false;
        console.log('result getUserAccept', result);
        result.data.forEach(async (user) => {
          this.userAccept.push({
            image: user.image ? user.image : '',
            name: user.firstName + ' ' + user.lastName,
            id: user._id,
            status: this.checkStatusTeacher(user.isTeacher),
            acceptMylib: user.acceptMylib,
            // group: user.user_groups
            group: await this.showGroupList(user.user_groups),
          });
        });
      }
    },
    async changeAcceptPage(page) {
      console.log('Yes');
      this.acceptPage = page;
      await this.acceptListInfo();
    },
    async rejectUser() {
      if (this.checkAccept == true) {
        let data = {
          id: this.reject_item,
        };
        let result = await rejectUserInCourse(data);
        if (result) {
          let resultTotalRequest = await getTotalRequest();
          store.commit('setTotal', resultTotalRequest.course);
          this.dialogDelete = false;
          this.checkAccept = null;
          await this.getlistUser();
          this.updateLearnerRequest();
        }
      } else {
        let data = {
          id: this.reject_item,
        };
        let result = await removeUserInCourse(data);
        if (result) {
          let resultTotalRequest = await getTotalRequest();
          store.commit('setTotal', resultTotalRequest.course);
          console.log(resultTotalRequest.course);
          this.dialogDelete = false;
          this.checkAccept = null;
          await this.getlistUser();
          this.updateLearnerRequest();
        }
      }
    },
    async changeRequestPage(page) {
      this.requestPage = page;
      await this.requestListInfo();
    },
    // async removeUser() {
    //   let data = {
    //     id: this.remove_item
    //   };
    //   let result = await removeUserInCourse(data);
    //   if (result) {
    //     this.dialogDelete = false;
    //     this.checkAccept = null;
    //     await this.getlistUser();
    //   }
    // },
    closeDialog() {
      this.dialogAddUserFromGroup = false;
      this.dialog = false;
      this.studentRoom = [];
      this.selectedRoom = null;
      this.userSearch = [];
      this.pageStd = 1;
      this.pageSearch = 1;
      this.searchData = '';
      (this.textWarning = ''),
        (this.typeWarning = ''),
        (this.showWarnnig = false);
    },
    closeDialogReject() {
      this.dialogDelete = false;
      this.checkAccept = null;
      this.remove_item = '';
    },
    // openRemoveDialog(item) {
    //   console.log(item);
    //   this.remove_item = item.id;
    // },
    openRejectDialog(item) {
      console.log(item);
      this.checkAccept = item.acceptMylib;
      this.reject_item = item.id;
      this.dialogDelete = true;
    },
    closeExcelDialog() {
      if (this.excelFile.length !== 0) {
        console.log(this.excelFile.length);
      } else {
        this.excelDialog = false;
        this.tableData = [];
        this.showExampleTable = true;
        this.showTabsResult = false;
      }
    },
    closeUserExcelDialog() {
      if (this.excelFile.length !== 0) {
        console.log(this.excelFile.length);
      } else {
        this.excelDialog = false;
        this.tableData = [];
        this.showExampleTable = true;
        this.showTabsResult = false;
      }
    },
    closeImportDialog() {
      this.importDialog = false;
      this.tableData = [];
      this.showExampleTable = true;
      this.showTabsResult = false;
      this.userUploadFail = [];
      this.userUploadRepeat = [];
      this.userUploadSuccess = [];
      this.selectRoom = null;
    },
    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (isLt1M) {
        return true;
      }
      this.$message({
        message: 'Please do not upload files larger than 1m in size.',
        type: 'warning',
      });
      return false;
    },
    handleSuccess({ results, header }, file) {
      console.log(header);
      this.excelFile = file;
      console.log('this.excelFile', results);
      this.tableData = results;
      this.showExampleTable = true;
      console.log('this.tableData', this.tableData);
    },
    async handlePreviewSuccess({ results, header }, file) {
      console.log(header);
      this.excelFile = file;
      console.log('this.excelFile', results);
      this.tableData = results;
      this.showExampleTable = true;
      await this.uploadFilePreview();
      console.log('this.tableData', this.tableData);
    },
    async uploadFilePreview() {
      //  this.excelFile
      let data = {
        idcourse: this.courseId,
        arrayusername: this.tableData,
      };
      this.userUploadFail = [];
      this.userUploadRepeat = [];
      this.userUploadSuccess = [];
      let result = await uploadUserToPreview(data);
      if (result) {
        this.showExampleTable = false;
        this.showTabsResult = true;
        this.userUploadSuccess = result.student_accept;
        this.userUploadFail = result.student_error.map((error) => ({
          ...error,
          note: 'ไม่มีในระบบ',
        }));
        this.userUploadRepeat = result.student_isHave;
      }
      console.log(result);
    },
    async uploadFile() {
      //  this.excelFile
      let data = {
        idcourse: this.courseId,
        // idprice:
        //   this.detail.prices && this.detail.prices.length !== 0
        //     ? this.detail.prices[0]._id
        //     : "",
        excel: this.tableData,
        idroom: this.sectionID,
      };
      this.userUploadFail = [];
      this.userUploadRepeat = [];
      this.userUploadSuccess = [];
      let result = await uploadUserInCourse(data);
      if (result) {
        this.showExampleTable = false;
        this.showTabsResult = true;
        for (let i = 0; i < result.student_accept.length; i++) {
          this.tableData.forEach((user) => {
            if (result.student_accept[i] === user.username) {
              this.userUploadSuccess.push(user);
            }
          });
        }
        for (let i = 0; i < result.student_error.length; i++) {
          this.tableData.forEach((user) => {
            if (result.student_error[i] === user.username) {
              this.userUploadFail.push(user);
            }
          });
        }
        for (let i = 0; i < result.student_isHave.length; i++) {
          this.tableData.forEach((user) => {
            if (result.student_isHave[i] === user.username) {
              this.userUploadRepeat.push(user);
            }
          });
        }
      }
      console.log(result);
    },
    openExpDateDialog(type, item) {
      console.log(type);
      this.data_type = type;
      if (this.data_type == 'search') {
        this.item_search = item;
      }
      this.exp_date_dialog = true;
    },

    async addUserByUser() {
      if (this.data_type == 'search' || this.data_type == 'clone') {
        this.addUserbySearch();
        this.closeDialogDateExp();
      } else {
        this.importStudentToCourse();
        this.closeDialogDateExp();
      }
    },

    async addUserbySearch() {
      if (this.data_type == 'search') {
        let index = this.userSearch.indexOf(this.item_search);
        console.log(index);
        let dt_start = new Date(this.date + ',' + '00' + ':' + '00');
        var startTime = dt_start.setTime(
          dt_start.getTime() - new Date().getTimezoneOffset() * 60 * 1000
        );
        console.log('this.detail', this.detail);
        let data = {
          idcourse: this.courseId,
          idstudent: this.item_search.id,
          idroom: this.sectionID,
          exp: this.date_type == 'type_spectify_exp' ? startTime : 0,
          pricing: 0,

          // idprice:
          //   this.detail.prices && this.detail.prices.length !== 0
          //     ? this.detail.prices[0]._id
          //     : ""
        };
        let result = await addUserInCourseBySearch(data);
        console.log('result', result);
        if (result.acceptMylib == true) {
          this.userSearch[index].status.push({
            text: 'เพิ่มสำเร็จ',
          });
          this.getlistUser();
          this.searchUserInfo();
          this.closeDialogDateExp();
        } else {
          this.userSearch[index].status.push({
            text: 'เพิ่มไม่สำเร็จ',
          });
          this.getlistUser();
          this.searchUserInfo();
          this.closeDialogDateExp();
        }
      } else {
        console.log('accept user Type studentRoom : ', this.studentRoom);
        let dt_start = new Date(this.date + ',' + '00' + ':' + '00');
        var expTime = dt_start.setTime(
          dt_start.getTime() - new Date().getTimezoneOffset() * 60 * 1000
        );
        console.log('this.detail', this.detail);
        let resultAddStudent = [];
        this.studentRoom.forEach(async (students) => {
          let data = {
            idcourse: this.courseId,
            idstudent: students.id,
            idroom: this.sectionID,
            exp: this.date_type == 'type_spectify_exp' ? expTime : 0,
            pricing: 0,
            // idprice:
            //   this.detail.prices && this.detail.prices.length !== 0
            //     ? this.detail.prices[0]._id
            //     : ""
          };
          let result = await addUserInCourseBySearch(data);
          resultAddStudent = result;
          this.studentRoom = [];
          console.log(resultAddStudent);

          // if (resultAddStudent.room) {
          //   console.log("เพิ่มไม่สำเร็จ");
          //   this.closeDialogDateExp();
          //   console.log("student list : ", this.studentRoom);
          // }
        });
        this.getlistUser();
        this.closeDialogDateExp();
        this.closeDialog();
      }
    },

    warnnig(text, type) {
      (this.textWarning = text),
        (this.typeWarning = type),
        (this.showWarnnig = true);
      console.log('warnnig fuction');
    },

    async importStudentToCourse() {
      let dt_start = new Date(this.date + ',' + '00' + ':' + '00');
      var startTime = dt_start.setTime(
        dt_start.getTime() - new Date().getTimezoneOffset() * 60 * 1000
      );

      let data = {
        idcourse: this.courseId,
        // idprice:
        //   this.detail.prices && this.detail.prices.length !== 0
        //     ? this.detail.prices[0]._id
        //     : "",
        exp: this.date_type == 'type_spectify_exp' ? startTime : 0,
        pricing: 0,
        arrayusername: this.tableData,
        // idroom: this.selectRoom
        idroom: this.sectionID,
      };
      // console.log(data)
      let result = await insertStudentToCourse(data);
      await this.getlistUser();
      await this.closeImportDialog();
      console.log(result);
    },
  },
};
</script>

<style scoped>
.style-ml {
  margin-left: inherit;
}

.md-fixed-max-width {
  max-width: 250px;
}

.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}

.text-primary {
  color: rgb(66, 154, 216) !important;
}

.fix-height {
  max-height: 32px;
}

.importError {
  color: red;
}

.rowContentmange {
  border-style: solid;
  border-radius: 15px;
  border-color: rgb(195, 195, 195);
  border-right-width: thin;
  border-top-width: thin;
  border-left-width: thin;
  border-bottom-width: thin;
}

.page-card {
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.p-relative {
  position: relative;
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 245px;
  z-index: 10000000;
}

/*user style*/
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.btn {
  color: gray;
  background-color: white;
  padding: 8px 20px;
}

.upload-btn-wrapper input[type='file'] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

.w-md-70 {
  width: 70%;
}

.border-1 {
  border: 1px solid #cfd8dc;
  border-top: 0;
}

.headerTable {
  text-align: center;
}

.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}

.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}

.rounded-card {
  border-radius: 8px;
}
</style>
